/* Gastrolux mega menus: portaled desktop panels avoid inherited header width and transform constraints. */
(function(){
  let entries=[],active=null,hideTimer=null;
  const media=window.matchMedia('(min-width:1100px)');
  function headerBottom(){
    const header=document.getElementById('site-control');
    return Math.min(window.innerHeight,Math.max(0,header?.getBoundingClientRect().bottom||0));
  }
  function updateTop(){
    document.documentElement.style.setProperty('--gwe-mega-top',headerBottom()+'px');
  }
  function cancelHide(){clearTimeout(hideTimer);hideTimer=null}
  function close(){
    cancelHide();
    if(!active)return;
    active.panel.classList.remove('is-open');
    active.panel.setAttribute('aria-hidden','true');
    active.trigger.setAttribute('aria-expanded','false');
    active=null;
  }
  function open(entry){
    if(!media.matches)return;
    cancelHide();
    if(active&&active!==entry)close();
    updateTop();
    active=entry;
    entry.panel.classList.add('is-open');
    entry.panel.setAttribute('aria-hidden','false');
    entry.trigger.setAttribute('aria-expanded','true');
  }
  function scheduleClose(entry){
    cancelHide();
    hideTimer=setTimeout(()=>{
      const inside=entry.item.matches(':hover')||entry.panel.matches(':hover')||entry.item.contains(document.activeElement)||entry.panel.contains(document.activeElement);
      if(active===entry&&!inside)close();
    },160);
  }
  function createEntry(panel){
    const kind=panel.classList.contains('gwe-nav--cookware')?'cookware':'kits';
    let item=panel.closest('li.contains-mega-menu');
    if(!item){
      const rows=[...document.querySelectorAll('#site-control .nav-row .tier-1>ul>li.contains-mega-menu')];
      item=rows.find(el=>kind==='cookware'?el.querySelector(':scope>a')?.textContent.toLowerCase().includes('ustensiles de cuisson'):el.querySelector(':scope>a')?.textContent.toLowerCase().includes('kits'));
    }
    const trigger=item?.querySelector(':scope>a');
    if(!item||!trigger)return null;
    const anchor=document.createComment('Gastrolux mega-menu original location');
    panel.parentNode.insertBefore(anchor,panel);
    const entry={kind,panel,item,trigger,anchor};
    trigger.setAttribute('aria-haspopup','true');
    trigger.setAttribute('aria-expanded','false');
    item.addEventListener('pointerenter',()=>open(entry));
    item.addEventListener('pointerleave',()=>scheduleClose(entry));
    item.addEventListener('focusin',()=>open(entry));
    item.addEventListener('focusout',()=>scheduleClose(entry));
    panel.addEventListener('pointerenter',cancelHide);
    panel.addEventListener('pointerleave',()=>scheduleClose(entry));
    panel.addEventListener('focusin',()=>open(entry));
    panel.addEventListener('focusout',()=>scheduleClose(entry));
    panel.addEventListener('keydown',e=>{
      if(e.key==='Escape'){e.preventDefault();close();trigger.focus()}
    });
    return entry;
  }
  function relocate(){
    close();
    entries.forEach(entry=>{
      if(media.matches){
        if(entry.panel.parentNode!==document.body)document.body.appendChild(entry.panel);
        entry.panel.classList.add('gwe-mega-portal');
        entry.panel.setAttribute('aria-hidden','true');
      }else{
        entry.panel.classList.remove('gwe-mega-portal','is-open');
        if(entry.anchor.isConnected)entry.anchor.parentNode.insertBefore(entry.panel,entry.anchor);
        entry.panel.removeAttribute('aria-hidden');
        entry.trigger.removeAttribute('aria-expanded');
      }
    });
    updateTop();
  }
  function init(){
    if(!document.querySelector('#site-control .nav-row'))return;
    document.querySelectorAll('body>ul.gwe-mega-portal').forEach(el=>el.remove());
    entries=[];
    document.querySelectorAll('#site-control .nav-columns.gwe-nav--cookware,#site-control .nav-columns.gwe-nav--kits').forEach(panel=>{
      const entry=createEntry(panel);
      if(entry)entries.push(entry);
    });
    if(!entries.length)return;
    relocate();
    document.addEventListener('pointerdown',event=>{
      if(active&&!active.panel.contains(event.target)&&!active.item.contains(event.target))close();
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){const trigger=active.trigger;close();trigger.focus()}});
    media.addEventListener?.('change',relocate);
    window.addEventListener('resize',updateTop,{passive:true});
    window.addEventListener('scroll',()=>{updateTop();if(active)close()},{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('#site-control'))init()});
})();
